import { parseApiResponse } from '@/shared/utils/apiResponse';
import { apiGet, apiPatch, apiPost } from '@/shared/utils/requestBuilder';

import type {
  CreateModeloNotificacaoDto,
  ModeloNotificacao,
  UpdateModeloNotificacaoDto,
} from '../types/modeloNotificacaoTypes';

const BASE = '/admin/arbitral/alert-templates';

export const modelosNotificacaoService = {
  async listar(): Promise<ModeloNotificacao[]> {
    const data = await parseApiResponse<{ items: ModeloNotificacao[] }>(await apiGet(BASE));
    return data.items;
  },

  async buscar(id: string): Promise<ModeloNotificacao> {
    return parseApiResponse<ModeloNotificacao>(await apiGet(`${BASE}/${id}`));
  },

  async criar(data: CreateModeloNotificacaoDto): Promise<ModeloNotificacao> {
    return parseApiResponse<ModeloNotificacao>(await apiPost(BASE, data));
  },

  async atualizar(id: string, data: UpdateModeloNotificacaoDto): Promise<ModeloNotificacao> {
    return parseApiResponse<ModeloNotificacao>(await apiPatch(`${BASE}/${id}`, data));
  },

  async alternarStatus(id: string): Promise<ModeloNotificacao> {
    return parseApiResponse<ModeloNotificacao>(await apiPatch(`${BASE}/${id}/status`));
  },
};
